import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import capitalize from 'underscore.string/capitalize';

import style from './style.css';

export const messagesShape = PropTypes.arrayOf(
  PropTypes.shape({
    text: PropTypes.node.isRequired,
    level: PropTypes.oneOf(['error', 'warning', 'info'])
  }).isRequired
);

export function checkMessagesOnSubmit(messages, success, failure) {
  if (messagesHaveLevel(messages, 'error')) {
    failure();
    window.scroll(0, 0);
  }
  else if (messagesHaveLevel(messages, 'warning')) {
    if (confirm('There are unsolved warning messages. ' +
                'Please confirm to ignore them.')) {
      success();
    }
  }
  else {
    success();
  }
}

export function messagesHaveLevel(messages, level) {
  return !!messages.find(m => m.level === level);
}

export default class Messages extends React.Component {

  static propTypes = {
    messages: messagesShape.isRequired,
    noIndent: PropTypes.bool.isRequired,
    scrollable: PropTypes.bool.isRequired,
    hide: PropTypes.bool.isRequired
  };

  static defaultProps = {
    noIndent: false,
    scrollable: false,
    hide: false
  };

  render() {
    const {messages, noIndent, scrollable, hide} = this.props;
    if (hide) { return null; }
    let className = style.messages;
    if (noIndent) {
      className = classNames(className, style.noIndent);
    }
    if (scrollable) {
      className = classNames(className, style.scrollable);
    }
    return (
      <ul className={className}>
        {messages.map(({text, level}, idx) => (
          <li key={idx} className={
             level === 'info' ? null : (level === 'error'? style.error: style.warning)}>
            {level === 'info' ? null : `${capitalize(level)}: `}
            {text}
          </li>
        ))}
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/fragments/messages/index.js